'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Button from '@mui/material/Button';
import { DevErrorRenderer } from '@/components/DevErrorRenderer';
import { ErrorPage } from '@/components/Layout/ErrorPage';
export default function Error(t0) {
  const $ = _c(9);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <br />;
    t2 = <br />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== reset) {
    t3 = <>An unexpected error has occurred. Please try again later or contact support if the problem persists.{t1}{t2}<Button variant="contained" onClick={() => reset()}>Try Again</Button></>;
    $[2] = reset;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== error) {
    t4 = <DevErrorRenderer error={error} />;
    $[4] = error;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <ErrorPage title="Internal Server Error" message={t3} code="500">{t4}</ErrorPage>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}